export const DEFAULT_UPLOAD_ACCEPT = ".pdf,.doc,.docx,.txt";
export const DEFAULT_UPLOAD_HELP = "Accepted file types: PDF, DOC, DOCX, TXT";

export type UploadConfig = {
  accept: string;
  help: string;
};

export function uploadConfigFor(documentType: string, fileLibraryUpload: UploadConfig) {
  if (documentType === "uploaded_file") {
    return fileLibraryUpload;
  }

  return {
    accept: DEFAULT_UPLOAD_ACCEPT,
    help: DEFAULT_UPLOAD_HELP,
  };
}
